var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardfront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.036 20.2632C5.058 20.2632 1.836 23.5605 1.836 27.6316C1.836 31.7026 5.058 35 9.036 35C13.014 35 16.236 31.7026 16.236 27.6316C16.236 23.5605 13.014 20.2632 9.036 20.2632ZM19.8 20.2632V35H34.2V20.2632H19.8ZM9 0L0 16.5789H18L9 0ZM31.05 0.921053C29.142 0.921053 27.792 1.95263 27 3.07632C26.208 1.95263 24.858 0.921053 22.95 0.921053C20.142 0.921053 18 3.27895 18 5.98684C18 9.67105 22.356 12.2868 27 16.5789C31.644 12.2868 36 9.67105 36 5.98684C36 3.27895 33.858 0.921053 31.05 0.921053Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardfront);
export default __webpack_public_path__ + "static/media/cardfront.5dc2d8e041915769565c5d871ab86413.svg";
export { ForwardRef as ReactComponent };